// extracted by mini-css-extract-plugin
var _1 = "alW0w";
var _2 = "xfTLC";
var _3 = "rNn7x";
var _4 = "AwUn9";
var _5 = "LdGZP";
export { _1 as "desktopMenu", _2 as "menuHeader", _3 as "menuItem", _4 as "mobileMenu", _5 as "sideMenu" }
